import { CognitoUser } from 'amazon-cognito-identity-js';
import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { userPool } from '../auth/cognito';
import { AuthLayout } from '../components/layout/AuthLayout';
import { PasswordField } from '../components/auth/PasswordField';

export function PasswordResetPage() {
  const [email, setEmail] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  function requestCode(event: FormEvent) {
    event.preventDefault(); setSubmitting(true); setError('');
    new CognitoUser({ Username: email.trim().toLowerCase(), Pool: userPool }).forgotPassword({
      onSuccess: () => { setSubmitting(false); setCodeSent(true); },
      inputVerificationCode: () => { setSubmitting(false); setCodeSent(true); },
      onFailure: (failure) => { setSubmitting(false); setError(messageOf(failure)); },
    });
  }
  function confirm(event: FormEvent) {
    event.preventDefault();
    if (password !== confirmation) return setError('Las contraseñas no coinciden.');
    setSubmitting(true); setError('');
    new CognitoUser({ Username: email.trim().toLowerCase(), Pool: userPool }).confirmPassword(code.trim(), password, {
      onSuccess: () => { setSubmitting(false); setDone(true); },
      onFailure: (failure) => { setSubmitting(false); setError(messageOf(failure)); },
    });
  }

  return <AuthLayout eyebrow="Recupera tu acceso" title={<>Elige una<br />contraseña nueva.</>} description="Te enviaremos un código de verificación al correo registrado en Argox.">
    {done ? <div className="auth-form"><h2>Contraseña actualizada</h2><p>Ya puedes iniciar sesión.</p><Link className="auth-primary" to="/login">Volver al inicio <span>→</span></Link></div> : !codeSent ? <form className="auth-form" onSubmit={requestCode}>
      <label>Correo electrónico<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="tu@negocio.mx" required autoComplete="email" autoFocus /></label>{error && <p className="auth-error">{error}</p>}<button className="auth-primary" disabled={submitting}>{submitting ? 'Enviando…' : 'Enviar código'} <span>→</span></button><Link className="auth-link" to="/login">Cancelar</Link>
    </form> : <form className="auth-form" onSubmit={confirm}><label>Código recibido<input value={code} onChange={(event) => setCode(event.target.value)} required inputMode="numeric" autoComplete="one-time-code" autoFocus /></label><PasswordField label="Nueva contraseña" value={password} onChange={setPassword} autoComplete="new-password" /><PasswordField label="Confirmar contraseña" value={confirmation} onChange={setConfirmation} autoComplete="new-password" />{error && <p className="auth-error">{error}</p>}<button className="auth-primary" disabled={submitting}>{submitting ? 'Guardando…' : 'Guardar contraseña'} <span>→</span></button></form>}
  </AuthLayout>;
}
function messageOf(failure: unknown) {
  const error = failure as { name?: string; code?: string; message?: string };
  const code = error?.name ?? error?.code;
  if (code === 'UserNotFoundException') return 'No encontramos una cuenta con ese correo.';
  if (code === 'CodeMismatchException') return 'El código no es correcto.';
  if (code === 'ExpiredCodeException') return 'El código venció. Solicita uno nuevo.';
  if (code === 'InvalidPasswordException') return 'La contraseña no cumple los requisitos (mínimo 10 caracteres, mayúscula, minúscula y número).';
  if (code === 'LimitExceededException' || code === 'TooManyRequestsException') return 'Demasiados intentos. Espera un momento antes de volver a intentar.';
  return failure instanceof Error ? failure.message : 'No pudimos completar la recuperación.';
}
